// import ie from './ie';

class Team {

    constructor() {
        this.root = $('.js-team-slider');
        this.slides = $('.js-team-slider-item', this.root);
        this.slidesBg = $('.js-team-slider-bg', this.root);
        this.bullets = $('.js-team-slider-bullets', this.root);
        this.next = $('.js-team-slider-next', this.root);
        this.prev = $('.js-team-slider-prev', this.root);
        this.promoButton = $('.js-promo-next', this.root);
        this.mapLinks = $('.js-team-promo-map area', this.root);
        this.currentSlide = this.slides.filter('._active').length ? this.slides.filter('._active') : this.slides.eq(0);
        this.animating = false;
        this.duration = 800;

        this.init();
    }

    init() {
        this.root.addClass('_dir-prev');
        this.currentSlide.next().addClass('_prev');

        this.slides.each((i,el) => {
            this.bullets.append('<i' + (i == this.currentSlide.index() ? ' class="_active"' : '') + '>');
            $(el).find('.js-team-slider-number').text($(el).index() > 9 ? $(el).index() : '0' + $(el).index());
            $(el).find('.js-team-slider-total').text(this.slides.length > 9 ? this.slides.length - 1 : '0' + (this.slides.length - 1));
        });

        if (this.root.data('preRender')) {
            this.root.on('preRenderEnd', () => {
                setTimeout(() => {
                    this.currentSlide.addClass('_active');
                    this.initFirstSlide();
                    this.bind();
                }, 30);
            });
        } else {
            this.currentSlide.addClass('_active');
            this.initFirstSlide();
            this.bind();
        }

        // переход на hash авигацию
        if (false) {
            window.addEventListener("hashchange", $.proxy(this.onPopstate, this), false); // IE11
        } else {
            window.addEventListener("popstate", $.proxy(this.onPopstate, this), false);
        }
        this.onPopstate();
    }

    bind() {
        if (device.mobile() || device.tablet()) {
            this.root.hammer().on('swipeleft', (ev) => {
                this.next.click();
            });

            this.root.hammer().on('swiperight', (ev) => {
                this.prev.click();
            });
        }

        if (device.desktop()) {
            this.mapLinks.on('click', (e) => {
                // e.preventDefault();
                // if (this.animating) return;
                // setTimeout(() => {
                //     this.slideTo(this.slides.eq($(e.currentTarget).data('slide')));
                // }, (device.mobile() || device.tablet()) ? this.duration * 2 : 0);

                // переход на hash авигацию
                e.preventDefault();
                if (this.animating) return;
                window.location.hash = '#' + $('.js-team-hash-nav [data-slide="' + $(e.currentTarget).data('slide') + '"]').attr('name');
            });
        }

        this.promoButton.on('click', ()=> {
            this.slideTo(this.slides.eq(1));
        });

        this.next.on('click', (e) => {
            //this.slideTo(this.currentSlide.next().length ? this.currentSlide.next() : this.slides.eq(0));

            // переход на hash авигацию
            let slide = this.currentSlide.next().length ? this.currentSlide.next() : this.slides.eq(0);
            if (slide.data('slide') == 0) {
                window.location.hash = '#team';
            } else {
                window.location.hash = '#' + $('.js-team-hash-nav [data-slide="' + slide.data('slide') + '"]').attr('name');
            }
        });

        this.prev.on('click', (e) => {
            //this.slideTo(this.currentSlide.prev().length ? this.currentSlide.prev() : this.slides.eq(this.slides.length - 1));

            // переход на hash авигацию
            let slide = this.currentSlide.prev().length ? this.currentSlide.prev() : this.slides.eq(this.slides.length - 1);
            if (slide.data('slide') == 0) {
                window.location.hash = '#team';
            } else {
                window.location.hash = '#' + $('.js-team-hash-nav [data-slide="' + slide.data('slide') + '"]').attr('name');
            }
        });

        this.bullets.find('i').on('click', (e) => {
            //this.slideTo(this.slides.eq($(e.currentTarget).index()));

            // переход на hash авигацию
            let slide = this.slides.eq($(e.currentTarget).index());
            if (slide.data('slide') == 0) {
                window.location.hash = '#team';
            } else {
                window.location.hash = '#' + $('.js-team-hash-nav [data-slide="' + slide.data('slide') + '"]').attr('name');
            }
        });
    }

    // переход на hash авигацию
    onPopstate() {
        let slide = $('.js-team-hash-nav [name="' + window.location.hash.substr(1) + '"]').data('slide') || (window.location.hash == '#team' ? 0 : undefined);

        if (slide != undefined && !this.animating) {
            if (slide != 0) {
                this.slides.eq(0).css('visibility', 'hidden');
                setTimeout(() => {
                    this.slides.eq(0).css('visibility', 'visible');
                }, 1000)
            }
            setTimeout(() => {
                this.slideTo(this.slides.eq(slide), 0);
            }, (device.mobile() || device.tablet()) ? this.duration * 2 : 0);
        }
    }

    slideTo(slide, duration) {
        if (this.animating || this.currentSlide[0] == slide[0]) return;
        this.animating = true;
        this.root.addClass('_animating');
        this.root.removeClass('_dir-prev _dir-next');
        this.slides.removeClass('_prev');
        if(this.currentSlide.index() - slide.index() == (this.slides.length - 1) || (this.currentSlide.index() - slide.index() != -(this.slides.length - 1) && this.currentSlide.index() < slide.index())) {
            this.root.addClass('_dir-next');
        } else {
            this.root.addClass('_dir-prev');
        }
        this.currentSlide.addClass('_leaving');
        this.bullets.find('i').removeClass('_active').eq(slide.index()).addClass('_active');

        setTimeout(() => {
            //this.animating = false;


            this.currentSlide.removeClass('_active').addClass('_prev');
            this.currentSlide = slide.addClass('_active');
            this.root.attr('data-active', this.currentSlide.index());
            this.slidesBg.css({
                color: this.currentSlide.data('colors').split(',')[0],
                fill: this.currentSlide.data('colors').split(',')[1]
            });
            this.currentSlide.css({
                fill: this.currentSlide.data('colors').split(',')[0]
            });
            if (this.currentSlide.index() === 0) {
                this.currentSlide.find('._hover-map').removeClass('_hover-map');
                this.currentSlide.find('.team-promo__content-item').eq(0).addClass('_hover-map');
            }
            this.root[0].offsetHeight; // задержка
            this.slides.removeClass('_leaving');

            setTimeout(() => {
                this.animating = false;
                this.root.removeClass('_animating');
            }, this.duration);
        }, duration != undefined ? duration : this.duration);
    }

    initFirstSlide() {
        //let teamPromo = $('.js-team-promo');
        let creative = $('.js-team-promo-creative');
        let persons = $('.js-team-promo-person');
        let content = $('.js-team-promo-content').children();

        if (device.desktop()) {
            $('.js-team-promo-map area').hover(function () {
                if ($(this).closest('.js-team-slider').hasClass('_animating')) return;
                content.eq(0).removeClass('_hover-map');
                persons.eq($(this).index()).add(creative).add(content.eq($(this).index() + 1)).addClass('_hover-map');
            }, function () {
                if ($(this).closest('.js-team-slider').hasClass('_animating')) return;
                content.eq(0).addClass('_hover-map');
                persons.eq($(this).index()).add(creative).add(content.eq($(this).index() + 1)).removeClass('_hover-map');
            });
            $('.js-team-promo-map').imageMapResize();
        }
    }
}

let team = new Team();

export default team;
